import { GETTERS, MUTATIONS } from "../store/wizard/types";

export const setParamsToStore = to => {
    const { applications, currentType, setpoint } = to.params;
    const consult = store.getters[GETTERS.GET_CONSULT];
    store.commit(MUTATIONS.SET_CONSULT, {
        ...consult,
        ...(applications && {
            applications: applications.split("-").map(app => {
                return parseInt(app);
            })
        }),
        ...(currentType && { currentType: getCurrentTypeId(currentType) }),
        ...(setpoint && { setpoint: getSetPoint(setpoint) })
    });
    validate(applications, currentType, setpoint);
};

export const checkEmptyObject = obj => {
    return Object.entries(obj).length === 0
};

const getCurrentTypeId = (typeParam) => {
    const currentType =  store.getters[GETTERS.GET_CATALOG].currentTypes.find(type => type.slug == typeParam);
    return currentType && currentType.id || '';
}

const getSetPoint = (setPointParam) => {
    const setpoint =  store.getters[GETTERS.GET_CATALOG].setpoints.find(setpoint => setpoint.slug == setPointParam);
    return setpoint && setpoint.id || '';
}

const validate = (applications, currentType, setpoint) => {
    if (applications !== undefined && ! store.getters[GETTERS.GET_APPLICATIONS].length ||
        currentType !== undefined && ! store.getters[GETTERS.GET_CURRENT_TYPE] ||
        setpoint !== undefined && ! store.getters[GETTERS.GET_SETPOINT]
    ) {
        throw new Exception('Invalid data');
    }
}
